import { AppDownloaderTab } from '@margex/ui'

import { TFunction } from '../../providers/TranslateProvider/TranslateProvider'
import { APPS_DOWNLOADER_LINKS } from '@constants'

export const getTabs = (t: TFunction): AppDownloaderTab[] => [
  {
    title: t('Margex App'),
    hint: t('Scan to Download iOS & Android App'),
    appLink: {
      title: t('Download App'),
      url: APPS_DOWNLOADER_LINKS.margexAppLink,
    },
    apkLink: {
      title: t('Download Apk'),
      url: APPS_DOWNLOADER_LINKS.margexApkLink,
    },
    isMain: true,
  },
  {
    title: t('Copy Trading App'),
    hint: t('Scan to Download iOS & Android App'),
    appLink: {
      title: t('Download App'),
      url: APPS_DOWNLOADER_LINKS.copyAppLink,
    },
    apkLink: {
      title: t('Download Apk'),
      url: APPS_DOWNLOADER_LINKS.copyApkLink,
    },
  },
]
